import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Self created Module imports
import { AuthenticationService } from './authentication/authentication.service';
import { NavShareService } from './core/nav-share.service';
import { CalendarService } from './calendar/calendar.service';
import { ColorService } from './shared/color.service';
import { ContingentService } from './contingent/contingent.service';
import { ContingentFacadeService } from './contingent/contingent-facade.service';
import { DateUtilsService } from './core/date-utils.service';
import { FormValidationService } from './core/form-validation.service';
import { ObjectUtilsService } from './core/object-utils.service';
import { MessageService } from 'primeng/api';

@NgModule({
    imports: [CommonModule],
    providers: [
        AuthenticationService,
        NavShareService,
        CalendarService,
        ColorService,
        ContingentService,
        ContingentFacadeService,
        DateUtilsService,
        FormValidationService,
        ObjectUtilsService,
        MessageService
    ]
})
export class ServicesModule {}
